// The dark footer bar, echoing the AWS console: utility links on the left,
// copyright + legal links on the right.
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer__left">
        <span className="footer__link">{'>_'} CloudShell</span>
        <span className="footer__link">Feedback</span>
        <span className="footer__link">Console Mobile App</span>
        <span className="footer__link">Language: English</span>
      </div>
      <div className="footer__right">
        <span className="footer__copy">
          © {year}, Toffs Technologies. All rights reserved.
        </span>
        <span className="footer__link">Privacy</span>
        <span className="footer__sep">|</span>
        <span className="footer__link">Terms</span>
        <span className="footer__sep">|</span>
        <span className="footer__link">Cookie preferences</span>
      </div>
    </footer>
  );
}
